NtechApp.Info = function() {
    this._sizesResolver = new NtechApp.SizesResolver();
    this._click = new NtechApp.TouchClickEvent();

    this._$info = null;
    this._rmTimeout = null;
    this._autoRmTimeout = null;

    this._create();
};

NtechApp.proto(NtechApp.Info, {
    _create: function() {
        var me = this;

        this._$info = $("<div class='ntechapp-infoWrapper'></div>");
        this._$info.appendTo("body");

        var $infoWrapper = $("<div/>").addClass("ntechapp-info");
        this._$info.append($infoWrapper);
        //$infoWrapper.text(message);
        var $message = $("<div/>").addClass("message");
        $infoWrapper.append($message);

        this._click.listen(this._$info, function(event) {
            me.off();
        });

        // Apply opacity: 0 per item right after append
        this._sizesResolver.getComputedCss(this._$info).opacity;
    },

    on: function(message, delay) {
        var me = this;
        var delay = delay || 1500;

        if(this._$info != null) {
            clearTimeout(this._rmTimeout);
            this._autoRmTimeout = setTimeout(function() { me.off(); }, delay);
            this._$info.css("visibility", "visible");
            this._$info.addClass("visible");
            this._$info.find(".message").text(message);
            return;
        }

        // this._$info = $("<div class='ntechapp-infoWrapper'></div>");
        // this._$info.appendTo("body");

        // var $infoWrapper = $("<div/>").addClass("ntechapp-info");
        // this._$info.append($infoWrapper);
        // $infoWrapper.text(message);

        // this._click.listen(this._$info, function(event) {
        //     me.off();
        // });

        // Apply opacity: 0 per item right after append
        //this._sizesResolver.getComputedCss(this._$info).opacity;
        //this._$info.addClass("visible");

        //this._autoRmTimeout = setTimeout(function() { me.off(); }, 1500);
    },

    off: function() {
        var me = this;
        clearTimeout(this._autoRmTimeout);
        //if(this._$info == null) return;

        this._$info.removeClass("visible");
        this._rmTimeout = setTimeout(function() {
            clearTimeout(me._autoRmTimeout);
            me._$info.css("visibility", "hidden");
            // if(me._$info == null) return;

            // me._$info.remove();
            // me._$info = null;
        }, 500);
    }
});